export default "__VITE_ASSET__Cuj$8MtC__"